'use client';

import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { Text, Icon, useTranslation, Link } from '@weareconceptstudio/core';

//* Style
import ShareStyle from './style';

const Share = ({ className, notShowTitle }) => {
	//! Next Navigation
	const pathname = usePathname();

	const { translate } = useTranslation();

	const url = useMemo(() => process.env.NEXT_PUBLIC_URL + pathname, [pathname]);

	const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
	const twitterUrl = `https://twitter.com/intent/tweet?url=${url}`;
	const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;

	return (
		<ShareStyle className={className || ''}>
			{notShowTitle ? null : (
				<Text className={'p3 font-montserrat-arm-medium white-color share'}>{translate('share')}</Text>
			)}

			<div className='wrapper-link'>
				<Link
					external
					url={twitterUrl}>
					<Icon
						className={'h5 media-share white-color'}
						name={'twitter'}
					/>
				</Link>

				<Link
					external
					url={linkedinUrl}>
					<Icon
						className={'h5 media-share white-color'}
						name={'linkedin'}
					/>
				</Link>

				<Link
					external
					url={facebookUrl}>
					<Icon
						className={'h5 media-share white-color'}
						name={'facebook'}
					/>
				</Link>
			</div>
		</ShareStyle>
	);
};

export default Share;
